import React, { useState, useEffect } from 'react';
import axios from 'axios';

interface FAQ {
  _id: string;
  question: string;
  answer: string;
  category: string;
}

const FAQ: React.FC = () => {
  const [faqs, setFaqs] = useState<FAQ[]>([]);
  const [category, setCategory] = useState('');
  const [loading, setLoading] = useState(true);
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  useEffect(() => {
    fetchFAQs();
  }, [category]);

  const fetchFAQs = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/faqs`, {
        params: { category: category || undefined }
      });
      setFaqs(response.data.data);
    } catch (error) {
      console.error('Error fetching FAQs:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold text-secondary mb-4">Frequently Asked Questions</h1>
          <p className="text-gray-600">Find answers to common questions about BSAF</p>
        </div>

        <div className="mb-8">
          <select
            value={category}
            onChange={(e) => setCategory(e.target.value)}
            className="input-field max-w-xs mx-auto block"
          >
            <option value="">All Categories</option>
            <option value="general">General</option>
            <option value="pricing">Pricing</option>
            <option value="services">Services</option>
            <option value="business">For Businesses</option>
            <option value="technical">Technical</option>
          </select>
        </div>

        {loading ? (
          <div className="text-center py-12">
            <i className="fas fa-spinner fa-spin text-4xl text-primary"></i>
          </div>
        ) : faqs.length === 0 ? (
          <div className="text-center py-12 bg-white rounded-lg">
            <i className="fas fa-question-circle text-6xl text-gray-300 mb-4"></i>
            <p className="text-gray-600">No FAQs found</p>
          </div>
        ) : (
          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <div key={faq._id} className="bg-white rounded-lg shadow-md overflow-hidden">
                <button
                  onClick={() => setOpenIndex(openIndex === index ? null : index)}
                  className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-gray-50 transition-colors"
                >
                  <span className="font-semibold text-secondary">{faq.question}</span>
                  <i className={`fas fa-chevron-${openIndex === index ? 'up' : 'down'} text-primary`}></i>
                </button>
                {openIndex === index && (
                  <div className="px-6 py-4 border-t bg-gray-50">
                    <p className="text-gray-700">{faq.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default FAQ;
